module.exports = __webpack_public_path__ + "media/graphics/Target-49972344.svg";